import { Lightbulb } from "lucide-react";

// Cream callout panel for tips.
export default function Callout({ children, title = "Tip" }) {
  return (
    <div className="rounded-2xl bg-brand-cream border border-brand-cream-dark p-4 sm:p-5 flex gap-3">
      <div className="flex-shrink-0 w-9 h-9 rounded-full bg-brand-orange/15 flex items-center justify-center">
        <Lightbulb className="w-5 h-5 text-brand-orange" />
      </div>
      <div>
        <p className="text-xs font-bold uppercase tracking-wide text-brand-orange mb-0.5">{title}</p>
        <p className="text-[15px] leading-snug text-brand-navy">{children}</p>
      </div>
    </div>
  );
}
